const UserFingerPrint = require("../user/userFingerPrint");

module.exports.install = (withoutPageView = false, isAsync = true, useFingerPrint = false) => {
  const fistScript = document.createElement('script');
  fistScript.src = "https://www.googletagmanager.com/gtag/js?id=" + __GAID__;
  fistScript.async = isAsync;
  const secondScript = document.createElement('script');
  secondScript.text = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date());gtag('config', '${__GAID__}', {'optimize_id': 'GTM-K9X8SMT', 'send_page_view': false});gtag('config', '${__GA4ID__}', {'send_page_view': false});`;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(fistScript);
  head.appendChild(secondScript);
  useFingerPrint && UserFingerPrint.setup(withoutPageView);
}

module.exports.gtag = function gtag() {window.dataLayer.push(arguments)};
